<div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2 p-0" [ngClass.gt-sm]="'mb-0 p-0 m-b-6'">
  <div class="p-10" fxlayout="row" fxlayoutalign="space-between center">
    <div class="pr-16 h3">
        Tabs
        <app-task-tab *ngIf="sharedService.selectedSelectionTabId === 5"></app-task-tab>
    </div>
  </div>
</div>